import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconArrowSpinRight12 from './IconArrowSpinRight12';
import IconArrowSpinRight16 from './IconArrowSpinRight16';
import IconArrowSpinRight20 from './IconArrowSpinRight20';
import IconArrowSpinRight24 from './IconArrowSpinRight24';
import IconArrowSpinRight32 from './IconArrowSpinRight32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconArrowSpinRight = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconArrowSpinRight12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconArrowSpinRight16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconArrowSpinRight20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconArrowSpinRight24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconArrowSpinRight32 {...props} />}
        </span>
    );
};
IconArrowSpinRight.displayName = 'FondueIconArrowSpinRight';

export default memo(IconArrowSpinRight);
